import { addRedirectParam } from 'helpers/url_helpers';

/* eslint-disable import/prefer-default-export */

export const BUSINESS_PATH = '/groups/business';
export const REQUEST_DEMO_PATH = '/groups/request_demo';
export const PRICING_PATH = '/pricing';
export const SIGNED_IN_HOME_PATH = '/home';
export const SIGN_UP_PATH = '/users/sign_up';
export const SIGN_IN_PATH = '/users/sign_in';

/* Route wrappers around url_helpers */
export const getSignInRedirectPath = redirectPath =>
  addRedirectParam(SIGN_IN_PATH, redirectPath);
export const getSignUpRedirectPath = redirectPath =>
  addRedirectParam(SIGN_UP_PATH, redirectPath);
